"use strict";

(function (window, document, com, undefined) {

    const init = function () {
        countdown.init();
        faq.init();
        video.init();

        let fld = helper.element(".js-login");
        if (fld) {
            fld.focus();
        }
    }


    init();

})(
    window,
    document,
    {
        helper,
        countdown,
        faq,
        video
    },
    undefined
);